import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import {
  getSideBarfilesActions,
  setPerformanceChildAction,
  settheStandardIDS,
  setTheNameFormForm,
  setThePerformsAgentRetrieveseparatestandACtion, ///---to get separate stand
  setThePerformsAgentCreateACtion,
  setThePerformsAgentEditACtion, /////---performances edit
  setPerformanceRetreveAction, ////----performance-----parent----calll
  setTheLastPerformanceIds, ///---lastIDs
  setThePerformsAgentRetrieveACtion,
  setTocalllRetrieve,
  setTheLastObjectwithTotal_points,

  setThePutIdAnswerIds,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/ManPowerPerfomance.scss";
import { useNavigate } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

const GrommingStandard = () => {
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const Navigate = useNavigate()
  var indexof;
  const dispatch = useDispatch();
  const [Datas, setDatas] = useState({});
  const [displaydata, setDisplayD] = useState();
  const [CheckedINfo, setCheckedInf] = useState();
  const [name, setName] = useState();
  const [previousecount, setpreviouscount] = useState(false);
  const [innerdata, setinnerdata] = useState();
  const [totalpointsc, settotalpointsc] = useState();
  const [mappedst, setmappedts] = useState();
  var performanceChildDatas =
    state.performanceChildTypeCall.performanceChildDatas;
  const [total_scorestta, setTotalPointsPut] = useState({ total_score: 0 });
  const [nextCall, setNextCall] = useState(false);
  const [nextmapids, setnexxtmapids] = useState();
  const formatKey = (key) => {
    // Remove underscores and convert to lowercase
    let formattedKey = key.replace(/_/g, " ").toLowerCase();
    // Capitalize first letter of each word
    formattedKey = formattedKey.replace(/\b\w/g, (char) => char.toUpperCase());
    return formattedKey;
  };
 const [callthenextapi , setnextapi] = useState(false)



  useEffect(()=>{
    if (
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {
      dispatch(
        setThePutIdAnswerIds(
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
            .id
        )
      );
      //perform_answer

    }
  },[state.PerformsFieldAgentRetrieve.performsRetrieveData ,state.ManPowerActiveDataTabs.ListNames ,callthenextapi]);

console.log(state.PerformsFieldAgentRetrieve.performsRetrieveData ,"oaieuqweiuqwie",
  state.ManPowerActiveDataTabs.LastIDSPerformanceidss ,
  state.ManPowerActiveDataTabs.NameForForm,
  state.ManPowerActiveDataTabs.LastIDSPerformanceidss ==
  state.ManPowerActiveDataTabs.NameForForm
);

  
  useEffect(() => {
    if (state.ManPowerActiveDataTabs.Ids != "") {
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          null &&
        Object.keys(
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
        ).map((innerKey, index) => {
          const value =
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer[innerKey];
          console.log(
            innerKey,
            "sdasdas=eh",
            state.ManPowerActiveDataTabs.NameForForm
          );

          if (
            typeof value === "object" &&
            value == null &&
            state.ManPowerActiveDataTabs.NameForForm != undefined && 

            state.ManPowerActiveDataTabs.NameForForm != null &&
            state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
              .replace(/\s+/g, "_")
              .replace(/[^a-z0-9_]/g, "_") === innerKey
          ) {
            const payload = {
              search: "",
              page_size: "",
              page: 1,
              id: state.ManPowerActiveDataTabs.Ids,
            };
            dispatch(setPerformanceChildAction(payload));
          }
        });
    }

    if (state.ManPowerActiveDataTabs.Ids != "") {
      if (
        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer ==
          null
      ) {
        const payload = {
          search: "",
          page_size: "",
          page: 1,
          id: state.ManPowerActiveDataTabs.Ids,
        };
        dispatch(setPerformanceChildAction(payload));
      }
    }
  }, [
    state.ManPowerActiveDataTabs.Ids,
    state.ManPowerActiveDataTabs.NameForForm,
  ]);
  ////--if the performances answer is null

  useEffect(() => {
    if (state.ManPowerActiveDataTabs.Ids != "") {
      if (
        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer ==
          null
      ) {
        const payload = {
          search: "",
          page_size: "",
          page: 1,
          id: state.ManPowerActiveDataTabs.Ids,
        };
        dispatch(setPerformanceChildAction(payload));
      }
    }
  }, [
    state.ManPowerActiveDataTabs.Ids,
    state.ManPowerActiveDataTabs.NameForForm,
  ]);

  const [datasforchild, setdatasforchild] = useState();

  useEffect(() => {
    if (state.performanceChildTypeCall.performanceChildDatas != undefined) {
      // Create grooming standard data

      const totalPoints =
        state.performanceChildTypeCall.Total_Count < 10
          ? `0${state.performanceChildTypeCall.Total_Count}`
          : state.performanceChildTypeCall.Total_Count;

      const groomingStandardData =
        state.performanceChildTypeCall.performanceChildDatas.map(
          (item, index) => ({
            answer: true,
            question:
              item.grading_name !== undefined && item.grading_name !== null
                ? item.grading_name
                : `Question ${index + 1}`,
          })
        );

      // Calculate total points
      const data = {
        data: groomingStandardData,
        total_points: totalPoints,
      };
      setdatasforchild(data);
    }
  }, [state.performanceChildTypeCall.performanceChildDatas]);

  console.log(datasforchild, "datasforchild");

  useEffect(() => {
    // if (nextCall) {
      if( state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
      state.ManPowerActiveDataTabs.LastIDSPerformanceidss ||callthenextapi == true ){
      if (state.ManPowerActiveDataTabs.EditIDs != "") {
        const payload = {
          EditId: state.ManPowerActiveDataTabs.EditIDs,
        };
        dispatch(setThePerformsAgentRetrieveACtion(payload));
      }
    }
  }, [
    state.ManPowerActiveDataTabs.EditIDs,
    state.ManPowerActiveDataTabs.NameForForm , 
    state.ManPowerActiveDataTabs.LastIDSPerformanceidss,
    nextCall,
    state.ManPowerActiveDataTabs.ListNames,
    callthenextapi
  ]);
  console.log(state.ManPowerActiveDataTabs.putIDS ,"asdsdasdassd",state.ManPowerActiveDataTabs.EditIDs);


  useEffect(() => {
    if (
      state.PerformsFieldAgentseparateRetrievename
        .performsRetrieveseparatData != undefined
    ) {
      const performsRetrieveseparatData =
        state.PerformsFieldAgentseparateRetrievename
          .performsRetrieveseparatData;

      console.log(
        innerdata,
        "sdsr8wersjinnerdatass",
        performsRetrieveseparatData
      );

      console.log("performanceChildDataretriev", innerdata);
    }
  }, [
    state.PerformsFieldAgentseparateRetrievename.performsRetrieveseparatData,
  ]);

  useEffect(() => {
    if (
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {
      console.log(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer,
        "perform_answer"
      );
      var mappedOne = [];
      Object.keys(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
      ).map((innerKey, index) => {
        const value =
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer[
            innerKey
          ];
        console.log("value", innerKey, typeof innerKey);

        if (value != null && value != undefined && typeof value === "object") {
          Object.entries(value).map(([subkey, subvalue], index) => {
            //  console.log(subkey, "subkeyiusdg"  , subvalue , index , innerKey);
            if (subkey == "total_points") {
              console.log("subvalue", subvalue);
              //   console.log({[innerKey ] : subvalue}, "hfgsdyfgsd");
              mappedOne.push({ [innerKey]: subvalue });

              setmappedts(mappedOne);
              // console.log(mappedOne, "mappedOne");
            }
          });
        }
      });
      // console.log(mappedst, "mappedst");
      dispatch(setTheLastObjectwithTotal_points(mappedOne)); ////----the---header--name---and---total_points
    }
  }, [state.PerformsFieldAgentRetrieve.performsRetrieveData, nextCall]);

  ////---parent------call-----
  useEffect(() => {
    if (state.ManPowerActiveDataTabs.Ids != undefined) {
      const payload = {
        id: state.ManPowerActiveDataTabs.Ids,
      };
      dispatch(setPerformanceRetreveAction(payload));
    }
  }, [state.ManPowerActiveDataTabs.Ids]);
  ///---dispatch separate performance stand---

  /////------retrieve- the send datas
  useEffect(() => {
    // if (
    //   state.ManPowerActiveDataTabs.tocallretrieve &&
    //   state.ManPowerActiveDataTabs.Ids != ""
    // ) {
    if (state.ManPowerActiveDataTabs.Ids != "") {
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          null &&
        Object.keys(
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
        ).map((innerKey, index) => {
          const value =
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer[innerKey];
          console.log(typeof value, "8wej=eh", value);
          // console.log(
          //   innerKey ==
          //     state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
          //       .replace(/\s+/g, "_")
          //       .replace(/[^a-z0-9_]/g, "_") && value != null,
          //   "pdsmsdaiosd"
          // );

          if (
            // state.ManPowerActiveDataTabs.NameForForm != undefined &&

            // state.ManPowerActiveDataTabs.NameForForm != null &&
            
            typeof value === "object" &&
            value != null &&
            state.ManPowerActiveDataTabs.NameForForm != undefined &&
            state.ManPowerActiveDataTabs.NameForForm != null &&
            state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
              .replace(/\s+/g, "_")
              .replace(/[^a-z0-9_]/g, "_") === innerKey
          ) {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            // console.log(year, "year", month );
            const payload = {
              question_id: state.ManPowerActiveDataTabs.Ids,
              userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
              year: year,
              month: month,
            };

            dispatch(setThePerformsAgentRetrieveseparatestandACtion(payload));
          }
        });
    }

    //   }
  }, [state.ManPowerActiveDataTabs.Ids]);

  useEffect(() => {
    if (
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
        null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
        .perform_id != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
        .perform_id != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
        .perform_id &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {
      Object.keys(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
      ).map((innerKey, index) => {
        // console.log(
        //   index,
        //   "asdaosudoouewqhr23u40923",
        //   innerKey,
        //   typeof innerKey
        // );
        // console.log(innerKey, "innsajdhasvderKey");

        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
            undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
            null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
            .perform_id != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
            .perform_id != null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types.perform_id.map(
            (item, index) => {
              if (
                innerKey ==
                item.grading_name
                  .toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_")
              )
                console.log(
                  innerKey ==
                    item.grading_name
                      .toLowerCase()
                      .replace(/\s+/g, "_")
                      .replace(/[^a-z0-9_]/g, "_"),
                  "transformedGradingName",
                  innerKey,
                  item.grading_name
                    .toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/[^a-z0-9_]/g, "_")
                );

              if (
                innerKey != undefined &&
                innerKey ==
                  item.grading_name
                    .toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/[^a-z0-9_]/g, "_") &&
                typeof innerKey === "object"
              ) {
                dispatch(setTocalllRetrieve(true));
              } else {
                dispatch(setTocalllRetrieve(false));
              }
            }
          );
      });
    }
  }, [state.ManPowerActiveDataTabs.Ids]);

  const [test, settest] = useState([]);

  useEffect(() => {
    if (
      // state.ManPowerActiveDataTabs.tocallretrieve &&
      // state.ManPowerActiveDataTabs.Ids != "" &&

      state.ManPowerActiveDataTabs.NameForForm != undefined &&
      state.ManPowerActiveDataTabs.NameForForm != null &&
      state.PerformsFieldAgentseparateRetrievename
        .performsRetrieveseparatData != null &&
      state.PerformsFieldAgentseparateRetrievename
        .performsRetrieveseparatData != undefined
    ) {
      console.log(state.ManPowerActiveDataTabs.Ids, "asdcasjxuas");
      ///--when the----get name is same then only it have to set the  current one
      if (
        state.ManPowerActiveDataTabs.Ids != "" &&
        state.PerformsFieldAgentseparateRetrievename
          .performsRetrieveseparatData != undefined &&
        state.PerformsFieldAgentseparateRetrievename
          .performsRetrieveseparatData != null
      ) {
        state.PerformsFieldAgentseparateRetrievename
          .performsRetrieveseparatData != undefined &&
          state.PerformsFieldAgentseparateRetrievename
            .performsRetrieveseparatData.data != undefined &&
          state.PerformsFieldAgentseparateRetrievename
            .performsRetrieveseparatData.data != null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData
            .perform_answer != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData
            .perform_answer != null &&
          Object.keys(
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          ).map((innerKey, index) => {
            const value =
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer[innerKey];
            console.log(typeof value, "8wej=eh", value);
            console.log(
              innerKey ==
                state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_") && value != null,
              "pdsmsdaiosd"
            );

            if (
              typeof value === "object" &&
              value != null &&
              state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                .replace(/\s+/g, "_")
                .replace(/[^a-z0-9_]/g, "_") === innerKey
            ) {
              /////------retrieve-----imeplement-----------------------------------------------
   
              // ///---updated response changes one
              setinnerdata((prevInnerData) => {
                const updatedInnerData = { ...prevInnerData };
                console.log(updatedInnerData, "updatedasdasdasInnerData");
                const groomingStandardKey =
                  state.ManPowerActiveDataTabs.NameForForm;
                const HeaderName =
                  state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/[^a-z0-9_]/g, "_");
                console.log(HeaderName, "HeaderName", groomingStandardKey);
                const data =
                  state.PerformsFieldAgentseparateRetrievename
                    .performsRetrieveseparatData.data;
                //  console.log(state.PerformsFieldAgentseparateRetrievename
                //   .performsRetrieveseparatData , "sdkjfisdeywuih");
                const innerdataslist =
                  state.PerformsFieldAgentseparateRetrievename
                    .performsRetrieveseparatData.data;

                console.log(
                  state.PerformsFieldAgentseparateRetrievename
                    .performsRetrieveseparatData.data,
                  "performsRetrsdfsdsieveseparatData"
                );

                console.log(updatedInnerData, "stanssdsdardsdfsdf");

                return {
                  ...updatedInnerData,
                  [HeaderName]: {
                    // ...data,
                    data: state.PerformsFieldAgentseparateRetrievename
                      .performsRetrieveseparatData.data,
                    // total_points: indexof < 10 ? `0${indexof}` : indexof,
                    // ["total_points"]:
                    //   state.PerformsFieldAgentseparateRetrievename
                    //     .performsRetrieveseparatData.total_points,
                    ["total_points"]:
                    state.performanceRetrieveTypeCall.performanceRetreveDatas.total_points,

                  },
                  ["user_id"]: state.ManPowerActiveDataTabs.EditIDs,
                  // ["total_points"]:
                  //   state.PerformsFieldAgentseparateRetrievename
                  //     .performsRetrieveseparatData.total_points,
                };
              });
            }
          });
      }
    }
  }, [
    state.PerformsFieldAgentseparateRetrievename.performsRetrieveseparatData,
    state.ManPowerActiveDataTabs.Ids,
  ]);

  ///----Next---last---objects----------
  var total_score = 0;

  /////-----Total----points-----------------------------
  useEffect(() => {
    if (
      // state.ManPowerActiveDataTabs.tocallretrieve &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {
      console.log(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer,
        "perform_answer"
      );

      var score = [];
      var mappedOne = [];
      var to;
      Object.keys(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
      ).map((innerKey, index) => {
        console.log(
          state.ManPowerActiveDataTabs.NameForForm,
          "dasdasdas234we",
          innerKey
        );
        const value =
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer[
            innerKey
          ];

        //  console.log("valueasdsdasd", innerKey, typeof innerKey, value , innerKey== state.ManPowerActiveDataTabs.NameForForm) ;
        if (value != null && value != undefined && typeof value === "object") {
          Object.entries(value).map(([subkey, subvalue], index) => {
            //  console.log(subkey, "subkeyiusdg"  , subvalue , index , innerKey);
            if (subkey == "total_points") {
              console.log("subvalue", subvalue);
              //   console.log({[innerKey ] : subvalue}, "hfgsdyfgsd");
              mappedOne.push({ [innerKey]: subvalue });
              setmappedts(mappedOne);
              console.log("mappedOne", subvalue + subvalue);
              total_score += subvalue;
              score.push(subvalue);
            }
          });
        }
      });

      // let values = 0;
      // for (let index = 0; index < score.length; index++) {
      //   const element = score[index];
      //   values += Number(element);
      // }

      // setTotalPointsPut({ ...total_scorestta, total_score: values });

      let values = 0;
      for (let index = 0; index < score.length; index++) {
        const element = score[index];
        values += Number(element);
      }

      const totalScoreString = values.toString();
      const truncatedTotalScore =
        totalScoreString.length <= 15
          ? totalScoreString
          : totalScoreString.slice(0, 15);

      setTotalPointsPut({
        ...total_scorestta,
        total_score: truncatedTotalScore,
      });

      console.log("sdasdasdasdasdas", values); // Output the sum

      dispatch(setTheLastObjectwithTotal_points(mappedOne)); ////----the---header--name---and---total_points
      console.log(
        state.ManPowerActiveDataTabs.LastObjectWithName_total,
        "LastObjectWithName_total"
      );
      console.log(total_score, "tosdasdasdas");
      //  setTotalPointsPut(total_score);
    }
  }, [state.PerformsFieldAgentRetrieve.performsRetrieveData]);

  var modifiedLabel;
  useEffect(() => {
    if (state.performanceChildTypeCall.performanceChildDatas != "") {
      const Keysent = [];
      state.performanceChildTypeCall.performanceChildDatas.map(
        (item, index) => {
          Keysent.push({ label: item.grading_name });

          modifiedLabel = item.grading_name
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^a-z0-9_]/g, "_");

          console.log(modifiedLabel, "modifiedLabel");
        }
      );
      setDisplayD(Keysent);
    }
  }, [
    state.performanceChildTypeCall.performanceChildDatas,
    state.ManPowerActiveDataTabs.Ids,
  ]);

  useEffect(() => {
    if (
      state.PerformsFieldAgentseparateRetrievename
        .performsRetrieveseparatData == null &&
      state.ManPowerActiveDataTabs.NameForForm != undefined
    ) {
      setName(state.ManPowerActiveDataTabs.NameForForm);
      const modifiedNameForForm = {
        ...state.ManPowerActiveDataTabs.NameForForm,
      };
    }
    // );

    var modifiedLabel = [];

    if (
      state.performanceChildTypeCall.performanceChildDatas != undefined &&
      state.ManPowerActiveDataTabs.NameForForm != undefined &&
      state.ManPowerActiveDataTabs.NameForForm != null &&
      state.ManPowerActiveDataTabs.Ids == state.ManPowerActiveDataTabs.Ids
    ) {
      console.log("sdfsdfio ip");
      state.ManPowerActiveDataTabs.NameForForm != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          null &&
        Object.keys(
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
        ).map((innerKey, index) => {
          const value =
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer[innerKey];
          console.log(
            innerKey,
            "8wej=eh",
            state.ManPowerActiveDataTabs.NameForForm
          );
          console.log(
            innerKey ==
              state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                .replace(/\s+/g, "_")
                .replace(/[^a-z0-9_]/g, "_") && value == null,
            "pdsmsdasdsadjhiosd"
          );

          if (
            typeof value === "object" &&
            value == null &&
            state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
              .replace(/\s+/g, "_")
              .replace(/[^a-z0-9_]/g, "_") === innerKey
          ) {
            state.performanceChildTypeCall.performanceChildDatas.forEach(
              (item) => {
                const key = item.grading_name;
                // .toLowerCase()
                // .replace(/\s+/g, "_")
                // .replace(/[^a-z0-9_]/g, "_");
                modifiedLabel.push(key != undefined ? key : "");

                // Push total_points to modifiedLabel
                modifiedLabel.push("total_points");
              }
            );
          }
        });

      ///--when the----get name is same then only it have to set the  current one
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          null &&
        Object.keys(
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
        ).map((innerKey, index) => {
          const value =
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer[innerKey];
          console.log(
            innerKey,
            "sdasdas=eh",
            state.ManPowerActiveDataTabs.NameForForm
          );

          if (
            typeof value === "object" &&
            value == null &&
            state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
              .replace(/\s+/g, "_")
              .replace(/[^a-z0-9_]/g, "_") === innerKey
          ) {
            setinnerdata((prevInnerData) => {
              const updatedInnerData = { ...prevInnerData };
              const groomingStandardKey =
                state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_");
              const performanceChildData =
                state.performanceChildTypeCall.performanceChildDatas;
              // const totalPoints =
              //   state.performanceChildTypeCall.Total_Count < 10
              //     ? `0${state.performanceChildTypeCall.Total_Count}`
              //     : state.performanceChildTypeCall.Total_Count;
              const totalPoints = state.performanceRetrieveTypeCall.performanceRetreveDatas.total_points

              console.log(
                state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_"),
                "sdfwedk bic"
              );
              // state.performanceRetrieveTypeCall.performanceRetreveDatas
              // Create grooming standard data
              console.log(performanceChildData ,"performanceChildData");
              
              const groomingStandardData = performanceChildData.map(
                (item, index) => ({
                  answer: true,
                  question:
                    item.grading_name !== undefined &&
                    item.grading_name !== null
                      ? item.grading_name
                      : `Question ${index + 1}`,
                })
              );

              // Calculate total points
              const data = {
                data: groomingStandardData,
                total_points: totalPoints,
              };
              console.log(updatedInnerData, "groomingStandardData", data);
              return {
                ...updatedInnerData,
                [groomingStandardKey]: data,
                user_id: state.ManPowerActiveDataTabs.EditIDs,
              };
            });
          }
        });

      if (
        state.ManPowerActiveDataTabs.Ids != "" &&
        state.ManPowerActiveDataTabs.Ids == state.ManPowerActiveDataTabs.Ids
      ) {
        if (
          state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData
            .perform_answer == null
        ) {
          setinnerdata((prevInnerData) => {
            const updatedInnerData = { ...prevInnerData };
            const groomingStandardKey =
              state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                .replace(/\s+/g, "_")
                .replace(/[^a-z0-9_]/g, "_");
            const performanceChildData =
              state.performanceChildTypeCall.performanceChildDatas;
            const totalPoints = state.performanceRetrieveTypeCall.performanceRetreveDatas.total_points
console.log(state.performanceRetrieveTypeCall.performanceRetreveDatas.points ,"total_points uqweiouwqieu" );

            console.log(
              state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
                .replace(/\s+/g, "_")
                .replace(/[^a-z0-9_]/g, "_"),
              "sdfwedk bic"
              ,
              totalPoints ,
              performanceChildData,
              state.performanceRetrieveTypeCall.performanceRetreveDatas
            );
            // Create grooming standard data
            const groomingStandardData = performanceChildData.map(
              (item, index) => ({
                answer: true,
                question:
                  item.grading_name !== undefined && item.grading_name !== null
                    ? item.grading_name
                    : `Question ${index + 1}`,
              })
            );

            // Calculate total points
            const data = {
              data: groomingStandardData,
              total_points: totalPoints,
            };
            console.log(updatedInnerData, "groomingStandardData", data);
            return {
              ...updatedInnerData,
              [groomingStandardKey]: data,
              user_id: state.ManPowerActiveDataTabs.EditIDs,
            };
          });
        }
      }
    }
  }, [
    state.ManPowerActiveDataTabs.NameForForm,
    state.ManPowerActiveDataTabs.ListNames,
    state.performanceChildTypeCall.performanceChildDatas,
    state.ManPowerActiveDataTabs.Ids,
    state.performanceRetrieveTypeCall.performanceRetreveDatas
  ]);

  const handleYesChange = (subKey, newValue, index) => {
    console.log(
      `Value of ${subKey} changed to ${newValue} at index ${index} , ${
        newValue ? newValue + 1 : newValue - 1
      }`
    );

    setinnerdata((prevInnerdata) => {
      const updatedInnerdata = { ...prevInnerdata };

      console.log(updatedInnerdata, "updatedInnasdasderdata");
      // Iterate over the keys of updatedInnerdata
      Object.keys(updatedInnerdata).forEach((key) => {
        // console.log(updatedInnerdata[key].total_points , "" , updatedInnerdata[key]);

        // Check if the key corresponds to grooming standard data
        if (
          updatedInnerdata[key] &&
          Array.isArray(updatedInnerdata[key].data)
        ) {
          // Update 'data' array in grooming standard
          console.log(updatedInnerdata[key], "updatedInnerdata[key] ");
          updatedInnerdata[key] = {
            ...updatedInnerdata[key],
            data: updatedInnerdata[key].data.map((item) => {
              // Check if the question matches subKey, then return a new object with updated answer
              if (item.question === subKey) {
                return { ...item, answer: newValue };
              }
              return item; // Return the original item for other questions
            }),
          };
        }

        console.log(updatedInnerdata, "updatedInnerdata");
        // Update 'total_points' value if it exists and is a valid number
        if (!isNaN(updatedInnerdata[key].total_points)) {
          // If 'newValue' is true, increment 'total_points' by 1; otherwise, decrement by 1
          // updatedInnerdata[key].total_points = (
          //   parseFloat(updatedInnerdata[key].total_points) + (newValue ? 1 : -1)
          // ).toFixed(4);


          // updatedInnerdata[key].total_points = (
          //   parseFloat(
          //     updatedInnerdata[key].total_points) + 
          //   (newValue ? (Number(state.performanceRetrieveTypeCall.performanceRetreveDatas.points)) 
          //    : - Number(state.performanceRetrieveTypeCall.performanceRetreveDatas.points))
          // ).toFixed(4);
          updatedInnerdata[key].total_points = (
            parseFloat(
              updatedInnerdata[key].total_points) + 
            (newValue ? (Number(state.performanceRetrieveTypeCall.performanceRetreveDatas.points)) 
             : - Number(state.performanceRetrieveTypeCall.performanceRetreveDatas.points))
          );
        }
      });

      return updatedInnerdata;
    });
  };

 



  const HandleNext = () => {
    //-----------The----last--------Page--------------------
    if (
      state.ManPowerActiveDataTabs.NameForForm !=
      state.ManPowerActiveDataTabs.LastIDSPerformanceidss
    ) {
      ////---setThePerformsAgentEditACtion----edit-----------------
      ////----------------setThePerformsAgentCreateACtion---------------

      if (
        // state.PerformsFieldAgentCreate.performsCreateData != null
        state.PerformsFieldAgentseparateRetrievename
          .performsRetrieveseparatData != undefined ||
        state.PerformsFieldAgentCreate.performsCreateData != undefined
      ) {

        state.ManPowerActiveDataTabs.Ids != "" &&
          state.ManPowerActiveDataTabs.total_ids.forEach((element, index) => {
            
            console.log(index == 1 ,"asbdksauj");
            if (state.ManPowerActiveDataTabs.Ids == element) {
              console.log(
                state.ManPowerActiveDataTabs.ListNames[index + 1],
                "sdfsdfhsdfh"
              );
              dispatch(
                settheStandardIDS(
                  state.ManPowerActiveDataTabs.total_ids[index + 1]
                )
              );
              dispatch(
                setTheNameFormForm(
                  state.ManPowerActiveDataTabs.ListNames[index + 1]
                )
              );
              setinnerdata("");

              if (
                state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
                state.ManPowerActiveDataTabs.LastIDSPerformanceidss
              ) {
                setNextCall(true);
              }


              if (
                // state.PerformsFieldAgentseparateRetrievename
                //   .performsRetrieveseparatData == undefined &&
                // !previousecount


        //         state.PerformsFieldAgentseparateRetrievename
        // .performsRetrieveseparatData.length == 0 , previousecount
        index == 0
        
              ) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                setnextapi(true);
                const payload = {
                  innerdata: innerdata,
                  question_id: state.ManPowerActiveDataTabs.Ids,
                  userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
                  year: year,
                  month: month,
                };
                dispatch(setThePerformsAgentCreateACtion(payload)); ///--create---
              } else if (
              
              
                // (state.PerformsFieldAgentCreate.performsCreateData != null &&
                //   state.PerformsFieldAgentseparateRetrievename
                //     .performsRetrieveseparatData != null) ||
                // state.PerformsFieldAgentseparateRetrievename
                //   .performsRetrieveseparatData != undefined ||
                // state.PerformsFieldAgentCreate.performsCreateData !=
                //   undefined ||
                // (previousecount &&
                //   state.PerformsFieldAgentCreate.performsCreateData !=
                //     undefined) && state.ManPowerActiveDataTabs.putIDS != ""


                index != 0

              ) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;

                const payload = {
                  innerdata: innerdata,
                  question_id: state.ManPowerActiveDataTabs.Ids,
                  userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
                  year: year,
                  month: month,

                  EditId: state.ManPowerActiveDataTabs.putIDS,
                  count: 1,
                };

                console.log(payload,"odiasudpoiasdpayload",index ,index != 0);
                setnextapi(true);
                dispatch(setThePerformsAgentEditACtion(payload)); ////----edit

                if (
                  state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
                  state.ManPowerActiveDataTabs.LastIDSPerformanceidss
                ) {
                  setNextCall(true);
                }
              }
            }
            setpreviouscount(true);
          });
      }
    }
    
    
    
    if (
      state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
      state.ManPowerActiveDataTabs.LastIDSPerformanceidss
    ) {
      setNextCall(true);
      setnextapi(true);
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      const payload = {
        innerdata: innerdata,
        question_id: state.ManPowerActiveDataTabs.Ids,
        userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
        year: year,
        month: month,

        EditId: state.ManPowerActiveDataTabs.putIDS,
        count: 1,
      };

    
      dispatch(setThePerformsAgentEditACtion(payload)); ////----edit

      console.log(state.ManPowerActiveDataTabs.NameForForm , state.ManPowerActiveDataTabs.LastIDSPerformanceidss , "LastIDSPerformanceidss" );
    }
  };

  const addedValue = (val) => {
    console.log(Number(val) + Number(val), "vaashdasdasul");
    return val + val;
  };

  console.log(state.ManPowerActiveDataTabs.NameForForm , state.ManPowerActiveDataTabs.LastIDSPerformanceidss , "LastIDSPerformanceidss" );


  ////--previous-------display---------

  const handelPrevious = () => {
    state.ManPowerActiveDataTabs.total_ids.forEach((element, index) => {
      // console.log(
      //   state.ManPowerActiveDataTabs.ListNames[index + 1],
      //   "dlfjadf",
      //   element
      // );
      //  console.log(index.length ,"index");
      if (state.ManPowerActiveDataTabs.Ids == element) {
        console.log(
          state.ManPowerActiveDataTabs.total_ids[index - 1],
          "sdhcowie8" , 
          state.ManPowerActiveDataTabs.total_ids , 

          state.ManPowerActiveDataTabs.total_ids.length -1
        );

        setinnerdata("");
        if (index === 0) {
          // dispatch(
          //   settheStandardIDS(state.ManPowerActiveDataTabs.total_ids[index - 1])
          // );
          dispatch(
            setTheNameFormForm(state.ManPowerActiveDataTabs.ListNames[state.ManPowerActiveDataTabs.ListNames.length - 1])
          ); ///---here---dispatch---Name
          dispatch(settheStandardIDS(state.ManPowerActiveDataTabs.total_ids[state.ManPowerActiveDataTabs.total_ids.length - 1]));


        }


        else { 
        dispatch(
          settheStandardIDS(state.ManPowerActiveDataTabs.total_ids[index - 1])
        );
        dispatch(
          setTheNameFormForm(state.ManPowerActiveDataTabs.ListNames[index - 1])
        ); ///---here---dispatch---Name

        }
        setpreviouscount(true);
      }
    });
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

   console.log(innerdata ,"342837408innerdata");
   
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Man Power Performance Form </h3>

            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/manpower"}
                  onClick={(e) => {
                    dispatch(getSideBarfilesActions("Man Power"));
                  }}
                >
                  Man Power Performance
                </NavLink>
              </li>
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/manpowerperform"}
                  onClick={(e) => {
                    dispatch(getSideBarfilesActions("Man Power"));
                  }}
                >
                  Man Power Performance Apply
                </NavLink>
              </li>

              <li class="breadcrumb-item">Man Power Performace form</li>
            </ul> */}
          </div>
        </div>



        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                Navigate("/manpowerperform");
              }}
            >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>

            </button>
          </div>
        </div>




        <div className="Header-Details" style={{ marginTop: "20px" }}>
          <div className="InnerDetails">
            <div className="InnerDetailPart">
              <div className="LOGO">
                <img src={profile2} />
              </div>
              {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id.first_name.toUpperCase() ? (
                <p>
                  {state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id.first_name.toUpperCase()}
                </p>
              ) : (
                <p>{"---"}</p>
              )}
            </div>
            <div className="ROLE">
              <div className="LOGO">
                {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                  undefined &&
                state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                  undefined &&
                state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                  null &&
                state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id
                  .user_role.role ? (
                  <h4>
                    {
                      state.PerformsFieldAgentRetrieve.performsRetrieveData
                        .user_id.user_role.role
                    }
                  </h4>
                ) : (
                  <h4>{"---"}</h4>
                )}
              </div>
            </div>
          </div>
        </div>

        {!nextCall &&
          // state.ManPowerActiveDataTabs.NameForForm != ///the  names are equals ,,, then its have to display the total_points
          //   state.ManPowerActiveDataTabs.LastIDSPerformanceidss &&
          innerdata != undefined &&
          innerdata != null &&
          Object.keys(innerdata).map((innerKey, index) => {
            const value = innerdata[innerKey];
            console.log(
              capitalizeFirstLetter(innerKey),
              value,
              "valueadf9ewmd",
              index,
              innerKey,
              innerKey == "total_points"
            );

            console.log(capitalizeFirstLetter(innerKey), "sdsdbfuwd9io");

            return (
              <div
                className="col-11  ManPowerPerformancesMark "
                key={index}
               
              >
                <div className="col-12">
                  <div style={{ padding: "10px 0px" }}>
                    {innerKey != "user_id" && innerKey !== "total_points" ? (
                      <h2 style={{ fontWeight: "600" }}>
                        {formatKey(innerKey)}
                      </h2>
                    ) : null}
                  </div>
                </div>
                {/* Render value  */}
                {typeof value === "object" ? (
                  // innerKey != undefined

                  <ul>
                    {Object.entries(value).map(([subKey, subValue], index) => {
                      console.log(subKey, subValue, value, "l0g0329210");
                      // console.log(
                      //   subKey === "total_points" && subKey !== "data",
                      //   "dsnosdf",
                      //   subKey
                      // );

                      return (
                        <>
                          <div className="row fortotalscores ">
                            <div className="col-12 mt-3">
                              {subKey !== "total_points" ? (
                                <>
                                  {subValue != null &&
                                    subValue != undefined &&
                                    subValue.map((item, index) => {
                                      console.log(index, item, "sjdsidwijd");

                                      return (
                                        // <h5 key={subKey}>{formatKey(subKey)}</h5> ///previous response data

                                        <div
                                          className="row"
                                          style={{ marginBottom: "16px" , marginLeft:"0ppx", marginRight:"0px" }}
                                        >
                                          <div className="col-6">
                                            <h4
                                              key={index}
                                              style={{
                                                fontWeight: "800",
                                                // marginBottom: "44px",
                                              }}
                                            >
                                              {item.question}
                                            </h4>
                                          </div>
                                          <div className="col-4">
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "12px",
                                                //marginBottom: "55px",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                style={{
                                                  width: "30px",
                                                  borderRadius: "12px",
                                                  cursor: "pointer",
                                                }}
                                                //checked={subValue}
                                                checked={item.answer}
                                                //onChange={(subKey ,subValue ,index)=>{
                                                //  handleYesChange(subKey ,subValue ,index)

                                                // }}
                                                onChange={() => {
                                                  handleYesChange(
                                                    // subKey,
                                                    item.question,
                                                    true,
                                                    index
                                                  );
                                                }}
                                              ></input>
                                              <label>{"yes"}</label>

                                              <input
                                                type="radio"
                                                style={{
                                                  width: "30px",
                                                  borderRadius: "12px",
                                                  cursor: "pointer",
                                                }}
                                                //checked={!subValue}
                                                checked={!item.answer}
                                                onChange={() => {
                                                  handleYesChange(
                                                    // subKey,
                                                    item.question,
                                                    false,
                                                    index
                                                  );
                                                }}
                                              ></input>
                                              <label>{"No"}</label>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </>
                              ) : null}
                            </div>
                            {subKey === "total_points" ? (
                              //  &&
                              ///  innerKey !== "user_id"
                              // <h5>Total Points: {value}</h5>
                              <div
                                className="row RoleButton totalscore"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  marginLeft:"0ppx", marginRight:"0px"
                                }}
                              >
                                <div
                                  className="col-6 mt-3"
                                  style={{ paddingLeft: "29px" }}
                                >
                                  <h2
                                    style={{ color: "#F16439", width: "500px" }}
                                  >
                                    Total Score
                                  </h2>
                                </div>
                                <div
                                  className="col-6 mt-3"
                                  style={{ paddingLeft: "59px" }}
                                >
                                  <button 
                                    class="btn SaveBtn ButtonCSS"
                                    style={{ padding: "6px 5px" }}
                                  >
                                    {value.total_points}
                                  </button>
                                </div>
                              </div>
                            ) : // <>
                            //   {" "}
                            //   {innerKey !== "total_points" ? (
                            //     <>
                            //       <div className="col-6">
                            //         {subValue != undefined &&
                            //           subValue.map((item, index) => {
                            //             console.log(
                            //               index,
                            //               item.answer,
                            //               "sjdsidw943jr9ijd"
                            //             );

                            //             return (
                            //               <div
                            //                 style={{
                            //                   display: "flex",
                            //                   gap: "12px",
                            //                   marginBottom: "55px",
                            //                 }}
                            //               >
                            //                 <input
                            //                   type="radio"
                            //                   style={{
                            //                     width: "30px",
                            //                     borderRadius: "12px",
                            //                     cursor: "pointer",
                            //                   }}
                            //                   //checked={subValue}
                            //                   checked={item.answer}
                            //                   //onChange={(subKey ,subValue ,index)=>{
                            //                   //  handleYesChange(subKey ,subValue ,index)

                            //                   // }}
                            //                   onChange={() => {
                            //                     handleYesChange(
                            //                       subKey,
                            //                       true,
                            //                       index
                            //                     );
                            //                   }}
                            //                 ></input>
                            //                 <label>{"yes"}</label>

                            //                 <input
                            //                   type="radio"
                            //                   style={{
                            //                     width: "30px",
                            //                     borderRadius: "12px",
                            //                     cursor: "pointer",
                            //                   }}
                            //                   //checked={!subValue}
                            //                   checked={!item.answer}
                            //                   onChange={() => {
                            //                     handleYesChange(
                            //                       subKey,
                            //                       false,
                            //                       index
                            //                     );
                            //                   }}
                            //                 ></input>
                            //                 <label>{"No"}</label>
                            //               </div>
                            //             );
                            //           })}
                            //       </div>
                            //     </>
                            //   ) : null}
                            // </>
                            null}
                          </div>
                        </>
                      );
                    })}
                  </ul>
                ) : (
                  <>
                    {/* {innerKey != undefined &&
                    value != undefined &&
                    value != null &&
                    innerKey !== "user_id" ? (
                      <p>
                        {innerKey}
                        {value.toString()}
                      </p>
                    ) : null} */}

                    {innerKey != undefined &&
                    value != undefined &&
                    value != null &&
                    innerKey !== "user_id" ? (
                      <div
                        className="row RoleButton totalscore"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          marginLeft: "20px",
                          
                        }}
                      >
                        <div
                          className="col-6 mt-3"
                          style={{ paddingLeft: "29px" }}
                        >
                          <h2 style={{ color: "#F16439", width: "500px" }}>
                            Total Score 
                          </h2>
                        </div>
                        <div
                          className="col-6 mt-3"
                          style={{ paddingLeft: "59px" }}
                        >
                          <button
                            class="btn SaveBtn"
                            style={{ padding: "6px 5px" }}
                          >
                            {value}
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            );
          })}

        <>
          {nextCall &&
            state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
              state.ManPowerActiveDataTabs.LastIDSPerformanceidss &&
            state.ManPowerActiveDataTabs.LastObjectWithName_total !=
              undefined &&
            Object.keys(
              state.ManPowerActiveDataTabs.LastObjectWithName_total
            ).map((item, index) => {
              console.log(item, "ite7hffm");
              const value =
                state.ManPowerActiveDataTabs.LastObjectWithName_total[item];
              console.log(typeof value === "object", "hnsa89jn");

              return (
                <>
                  {typeof value === "object" ? (
                    <>
                      {Object.entries(value).map(
                        ([subKey, subValue], index) => {
                          console.log(
                            subKey,
                            "subkeyvaluesadas",
                           
                          );
                          addedValue(subValue);

                          //                          console.log(addedValue(subValue), "addedValue"); // Check the calculated addedValue

                          return (
                            <>
                              <div
                                div
                                className="row"
                                style={{
                                  marginRight: "0px",
                                  padding: "12px 40px",
                                }}
                              >
                                <div className="col-6">
                                  <h5
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {formatKey(subKey)}
                                  </h5>
                                </div>
                                <div className="col-6">
                                  <p
                                    style={{
                                      color: "#F26639",
                                      fontWeight: "600",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {subValue}
                                  </p>
                                </div>
                              </div>
                            </>
                          );
                        }
                      )}
                    </>
                  ) : null}
                </>
              );
            })}

          {nextCall &&
          state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
            state.ManPowerActiveDataTabs.LastIDSPerformanceidss ? (
            <>
              <div
                className="row RoleButton"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  padding: "0px 19px",
                  marginBottom: "30px",
                  bordeR: "4px solid red",
                }}
              >
                <div className="col-6 mt-3" style={{ paddingLeft: "29px" }}>
                  <h2 style={{ color: "#F16439", width: "500px" }}>
                    Total Score
                  </h2>
                </div>
                <div className="col-6 mt-3" style={{ paddingLeft: "5px" }}>
                  <button class="ButtonCSS SaveBtn" style={{ textAlign: "center" }}>
                    {total_scorestta.total_score}
                  </button>
                </div>

                <div
                  className="button1"
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-start",
                    marginLeft: "34px",
                    marginTop: "50px",
                  }}
                >
                  {/* {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .user_id != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .user_id != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id.first_name.toUpperCase() ? (
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        width: "100%",
                      }}
                    >
                      {state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id.first_name.toUpperCase()}
                      _is Scoring and
                      <span
                        style={{
                          color: "#F37338",
                          fontWeight: "900",
                        }}
                      >
                        {" "}
                        "A"
                      </span>
                      Grade
                    </p>
                  ) : (
                    <p>{"---"}</p>
                  )} */}
                  <p style={{width:"48%"}}></p>
                  <button
                    class=" SaveBtn ButtonCSS"
                    style={{
                      fontWeight: "600",
                      // width: "50%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    // total_score
                    onClick={(e) => {
                      const payload = {
                        // innerdata: total_scorestta,
                        innerdata: {
                          total_score:total_scorestta.total_score,
                          user_id:state.ManPowerActiveDataTabs.EditIDs,
                          is_completed:true

                        },
                        EditId: state.ManPowerActiveDataTabs.putIDS,
                        count: 2,
                      };
                      dispatch(setThePerformsAgentEditACtion(payload));
                    }}
                  >
                    {"update"}
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </>
        {!nextCall ? (
          // state.ManPowerActiveDataTabs.NameForForm != ///the  names are equals ,,, then its have to display the total_points
          // state.ManPowerActiveDataTabs.LastIDSPerformanceidss

          <div
            className=" col-9 RoleButton"
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "40px",
              // width: "90%",
              marginTop: "30px",
            }}
          >
            {previousecount ? (
              <button
                class="btn CancelBtn"
                onClick={(e) => {
                  handelPrevious();
                }}
              >
                Previous
              </button>
            ) : null}
            <button
              class="btn CancelBtn"
              onClick={(e) => {
                HandleNext();
              }}
            >
              Next
            </button>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default GrommingStandard;
